import { ToolService } from '@services/tool.service';
import { ToolUsageService } from '@services/tool-usage.service'
import { UserService } from '@services/user.service';
import { ObservableService } from '@services/observable.service'
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../shared/shared.module';
import { CoreRoutingModule } from './core.routing';

import { CoreComponent } from './core.component';

import {
    AdminModule,
    AtomOperatorModule,
    KardexOperatorModule,
    LineSetterModule,
    MilkrunOperatorModule,
    ServiceOperatorModule
} from '../roles';

import { AppToolbarComponent, SidebarComponent } from './layout';

import { IntroComponent } from './layout/intro/intro.component';
import { SectionSelectionComponent } from './layout/section-selection/section-selection.component';
import { TechnicalProductionBadgeScanComponent } from './layout/technical-production-badge-scan/technical-production-badge-scan.component';
import { NotificationService } from "@services/notification.service";
import { DemoModule } from "@app/demo/demo.module";
import { PartNumbersService } from "@services/part-numbers.service";
import { TreeAdapter } from "@app/shared/util/tree-adapter.utils";
import { ToolTransportService } from "@services/tool-transport.service";
import { CacheService } from '@services/cache.service';
import { InactivityService } from '@services/inactivity.service';
import { NavigationService } from '@services/navigation.service';
import { ResolutionService } from "@services/resolution.service";

@NgModule({
    declarations: [
        CoreComponent,
        AppToolbarComponent,
        SidebarComponent,
        IntroComponent,
        SectionSelectionComponent,
        TechnicalProductionBadgeScanComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        TranslateModule,
        AdminModule,
        LineSetterModule,
        AtomOperatorModule,
        KardexOperatorModule,
        MilkrunOperatorModule,
        ServiceOperatorModule,
        SharedModule,
        CoreRoutingModule,
        DemoModule
    ],
    providers: [
        UserService,
        ToolService,
        ToolUsageService,
        NotificationService,
        PartNumbersService,
        TreeAdapter,
        ToolTransportService,
        ObservableService,
        CacheService,
        InactivityService,
        NavigationService,
        ResolutionService
    ]
})
export class CoreModule {
}
